import IconTrash1 from "@/icons/IconTrash1";
import React from "react";
import { IntegrationFieldMap } from "./IntegrationMappingPanel";

export interface Option {
  value: any;
  label: string;
  key?: string;
  disabled?: boolean;
}

interface Props {
  mappedField: IntegrationFieldMap;
  i: number;
  fieldLabel: string;
  updateMappedField: (i: number, field: IntegrationFieldMap) => void;
  metadata: Option[];
  isLoading: boolean;
  deleteRow: (i: number) => void;
  showSavedMessage: () => void;
}

export default function IntegrationMappingRow(props: Props) {
  const { mappedField, i, fieldLabel, metadata, isLoading } = props;

  const handleChange = (callback: () => void) => {
    callback();
    props.showSavedMessage();
  };

  return (
    <tr key={i}>
      <td className="pb-4 pr-5 pl-4">
        <div className="relative text-slate-800 text-sm font-normal border border-slate-300 rounded-lg">
          <select
            className="w-full text-sm font-normal bg-white rounded-lg border-none px-4 py-2 appearance-none focus:outline-none focus:ring-0"
            value={mappedField.field?.value || ""}
            aria-label={`${fieldLabel} selection`}
            onChange={(e) =>
              handleChange(() =>
                props.updateMappedField(i, {
                  ...mappedField,
                  field: {
                    value: e.target.value,
                    label: e.target.options[e.target.selectedIndex].text
                  }
                })
              )
            }
            disabled={isLoading}
          >
            {isLoading ? (
              <option>Loading...</option>
            ) : (
              metadata.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))
            )}
          </select>
          <div className="absolute right-2 top-1/2 -translate-y-1/2 pointer-events-none flex items-center text-slate-400">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
      </td>
      <td className="pb-4">
        <input
          className="w-full h-max focus:outline-none p-2 text-slate-800 text-sm font-normal border border-slate-300 rounded-lg"
          value={mappedField.defaultValue || ""}
          placeholder="Enter default value"
          aria-label="Default value"
          onChange={(e) =>
            handleChange(() =>
              props.updateMappedField(i, {
                ...mappedField,
                defaultValue: e.currentTarget.value
              })
            )
          }
        />
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={mappedField.create}
          aria-label="Create"
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(i, {
                ...mappedField,
                create: !mappedField.create
              })
            )
          }
        />
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={mappedField.usedForSearching}
          aria-label="Used for searching"
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(i, {
                ...mappedField,
                usedForSearching: !mappedField.usedForSearching
              })
            )
          }
        />
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={mappedField.showWhenSelected}
          aria-label="Show when selected"
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(i, {
                ...mappedField,
                showWhenSelected: !mappedField.showWhenSelected
              })
            )
          }
        />
      </td>
      <td className="pb-4">
        <input
          type="checkbox"
          className="input w-full"
          checked={mappedField.showInSearch}
          aria-label="Show in search"
          onChange={() =>
            handleChange(() =>
              props.updateMappedField(i, {
                ...mappedField,
                showInSearch: !mappedField.showInSearch
              })
            )
          }
        />
      </td>
      <td className="text-center justify-center items-center place-self-center">
        <button
          className="py-2 px-4 cursor-pointer justify-center flex"
          onClick={() => props.deleteRow(i)}
          aria-label="Delete field mapping"
          type="button"
        >
          <IconTrash1 />
        </button>
      </td>
    </tr>
  );
}
